export default __webpack_public_path__ + "static/media/Uunlimited-logo-bg-white.6e78b315.jpg";